// TODO: this entire file uses scary getElementById with no error handling.

export const scrollToLogin = (props, windowWidth) => {
  if (props) {
    const signinForm = document.getElementById("signin");
    const expandable = document.getElementById("expandable");
    const signupBtn = document.getElementById("signupBtn");
    if(expandable) {
      if (windowWidth >= 768) {
        expandable.style.maxHeight = "243px";
      } else {
        expandable.style.maxHeight = "310px";
      }
    }
    if(signupBtn) signupBtn.style.display = "block";
    if(signinForm) {
      signinForm.style.display = "flex";
      signinForm.scrollIntoView({ behavior: "smooth" });
    }
  }
};
export const scrollToSignup = (props, windowWidth) => {
  if (props) {
    const signupForm = document.getElementById("signup");
    const expandable = document.getElementById("expandable");
    const signupBtn = document.getElementById("signupBtn");
    const confirmationcode = document.getElementById("confirmationcode");

    if(signupForm) signupForm.style.display = "flex";
    if(signupBtn) signupBtn.style.display = "none";
    if(confirmationcode) confirmationcode.style.display = "none";

    // expandable.style.maxHeight = "440px";
    if(expandable) {
      if (windowWidth >= 768) {
        expandable.style.maxHeight = "440px";
      } else {
        expandable.style.maxHeight = "515px";
      }
    }

    const signinForm = document.getElementById("signin");
    if(signinForm) signinForm.style.display = "none";
    if(expandable) expandable.style.transition = "max-height 0.3s ease-out";

    if(signupForm) signupForm.scrollIntoView({ behavior: "smooth" });
  }
};

export const scrollToConfirmationCode = () => {
  const signupForm = document.getElementById("signup");
  const expandable = document.getElementById("expandable");
  const signupBtn = document.getElementById("signupBtn");
  const signinForm = document.getElementById("signin");

  const confirmationcode = document.getElementById("confirmationcode");

  if(signinForm) signinForm.style.display = "none";
  if(signupForm) signupForm.style.display = "none";
  if(signupBtn) signupBtn.style.display = "none";
  if(expandable) expandable.style.maxHeight = "250px";
  if(confirmationcode) {
    confirmationcode.style.display = "block";
    confirmationcode.scrollIntoView({ behavior: "smooth" });
  }
};

export const scrollToResetPassword = () => {
  const signupForm = document.getElementById("signup");
  const expandable = document.getElementById("expandable");
  const confirmationcode = document.getElementById("confirmationcode");

  if(signupForm) signupForm.style.display = "none";
  if(confirmationcode) confirmationcode.style.display = "none";
  if(expandable) expandable.style.maxHeight = "380px";
};
